import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplyJobServiceService {

  private baseUrl = environment.baseUrl + environment.applyJobEndpoint;

  private stateEndpoint = '/api/api/v1/DataSetup/getallstates';

  constructor(private http: HttpClient) { }


   applyJob(payload: any) {
    return this.http.post(`${this.baseUrl}`, payload);
  }

   getAllStates(): Observable<any> {
    return this.http.get<any>(`${environment.surveyapp_baseurl}${this.stateEndpoint}`);
  }



}
